import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { Locales as LocalesGenerator } from "@core/locales";
import AccessLevelPicker from "./AccessLevelPicker.json";
import AccessTable from "./AccessTable.json";
import ApiKeyCopyValuePrompt from "./ApiKeyCopyValuePrompt.json";
import APIKeysAccessTable from "./APIKeysAccessTable.json";
import GroupsAccessTable from "./GroupsAccessTable.json";
import PrivilegesRows from "./PrivilegesRows.json";
import PrivilegesTable from "./PrivilegesTable.json";
import PrivilegesTabs from "./PrivilegesTabs.json";
var req = {
    AccessLevelPicker: AccessLevelPicker,
    AccessTable: AccessTable,
    ApiKeyCopyValuePrompt: ApiKeyCopyValuePrompt,
    APIKeysAccessTable: APIKeysAccessTable,
    GroupsAccessTable: GroupsAccessTable,
    PrivilegesRows: PrivilegesRows,
    PrivilegesTable: PrivilegesTable,
    PrivilegesTabs: PrivilegesTabs
};
var translations = {};
Object.keys(req).forEach(function(key) {
    var parts = key.split("/");
    var roots = parts.splice(0, parts.length - 2);
    var map = translations;
    roots.forEach(function(root) {
        if (!map[root]) {
            map = _object_spread_props(_object_spread({}, map), _define_property({}, root, {}));
        }
        map = map[root];
    });
    translations = _object_spread({}, map, req[key]);
});
var enDictionary = {
    locale: "en",
    translations: translations
};
export var Locales = new LocalesGenerator({
    dictionaries: [
        enDictionary
    ],
    defaultLocale: "en"
});

//# sourceMappingURL=Locales.js.map